import { z } from 'zod';
import { TalkConst } from '@axiom/const';
import { SchemaEmail, ZodArrayToEnum } from '@axiom/types';

export const ContactAxiomModalSchema = z.object({
  phoneNumber: z.string().nullable(),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  email: SchemaEmail,
  workDescription: z.string().max(1000).nullable(),
  candidateId: z.string().uuid(),
  candidateName: z.string().nullable(),
  candidatePhotoURL: z.string().nullable(),
  createAccount: z.boolean().default(false),
  accountName: z.string(),
  requestType: z.enum(ZodArrayToEnum(Object.values(TalkConst.requestType))),
});

export type ContactAxiomModal = z.infer<typeof ContactAxiomModalSchema>;
